import {placeholderQuestion} from './questionTemplates'

export function newSetTemplate() {
	const nowDate = new Date()

	const randId='00000000'.replace(/0/g,function(){return (~~(Math.random()*16)).toString(16)})

	//create a set with the default stuff
	const newSet = {
		'folder': null,
		'name': 'Untitled Set',
		'description': 'Empty description',
		'questions': [{...placeholderQuestion(),
			'questionId':randId
		}],
		'clientModified': nowDate,
		'archived': false,
		'userCreated': nowDate,


	}
	return newSet
}

 


// WEBPACK FOOTER //
// ./src/utils/editors/setTemplates.js